import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import * as Chiamate from '..';
import { ApplicationState } from '../..';
import { Matricola, TipoIntervento } from '../../core-assistenza';
import SelezionaMatricolaComputer from './SelezionaMatricolaComputer';
import SelezionaMatricolaMobile from './SelezionaMatricolaMobile';
import { mediaStyles, MediaContextProvider, Media } from '../../core'; 

type OwnProps = {
    tipologia: TipoIntervento,
    onSelectMatricola: (matricola: Matricola) => void
}

const connector = connect(
    (state: ApplicationState) => ({
        destinatariMatricole: state.chiamate.destinatariMatricole.lista
    }),
    Chiamate.actions
)

type PropsFromRedux = ConnectedProps<typeof connector>

type SelezionaMatricolaProps = 
    PropsFromRedux &
    OwnProps

type SelezionaMatricolaState = {
    sidebarVisible: boolean,
    active: string,
    selezionato: string
}

class SelezionaMatricola extends React.Component<SelezionaMatricolaProps, SelezionaMatricolaState> {
    constructor(props: SelezionaMatricolaProps) {
        super(props);

        this.state = { 
            sidebarVisible: false, 
            active: '',
            selezionato: '' 
        };
    }

    componentDidMount() {
        const { tipologia } = this.props;

        this.props.loadMatricole(tipologia);
    }

    render() {
        const destinatariMatricole = this.props.destinatariMatricole || [];

        return (
            <>
                <style>{mediaStyles}</style>
                <MediaContextProvider>
                    <Media at="mobile">
                        <SelezionaMatricolaMobile 
                            tipologia={this.props.tipologia}
                            destinatariMatricole={destinatariMatricole}
                            onSelectMatricola={this.props.onSelectMatricola}
                            loadMatricole={this.props.loadMatricole}
                        />
                    </Media>
                    <Media greaterThanOrEqual="tablet">
                        <SelezionaMatricolaComputer 
                            tipologia={this.props.tipologia}
                            destinatariMatricole={destinatariMatricole}
                            onSelectMatricola={this.props.onSelectMatricola}
                            loadMatricole={this.props.loadMatricole}
                        />
                    </Media>
                </MediaContextProvider>
            </>
        );
    }
}

export default connector(SelezionaMatricola);